import React from 'react';
import { IonAlert, IonBackButton, IonButtons, IonCard, IonContent, IonHeader, IonItem, IonLabel, IonList, IonListHeader, IonPage, IonToolbar } from '@ionic/react';

//	L O C A L I Z A T I O N

import { locale___App } from '../../../App.locale';
import { locale___SbSettingsMainPage } from './sb-settings-main.locale';

//	S T Y L E

import './sb-settings-main.scss';

//	I N T E R F A C E S

import { interface___IonAlert } from '../../../interfaces/interface.alert';

//	S T A T E   -   P R O P S

import { props___SbSettingsPage, state___SbSettingsMainPage, state___SbSettingsMainPage___default } from './sb-settings-main.state';

//	S E R V I C E S

import { service_LocalizationService } from '../../../services/service-localization';
import { service_RestAuthLogoutService } from '../../../services/service-auth-logout';

//	C O M P O N E N T S

import ComCopyrightComponent from '../../../components/com-copyright/com-copyright';

//	M O D A L S

import MdEntryLanguageModal from '../../../modals/md-entry-language/md-entry-language';

//	C L A S S

export default class SbSettingsMainPage extends React.Component<props___SbSettingsPage, state___SbSettingsMainPage> {

//#region 																							D E C L A R A T I O N S

	private readonly _LOCALE: service_LocalizationService = new service_LocalizationService();
	private readonly _AUTH_LOGOUT: service_RestAuthLogoutService = new service_RestAuthLogoutService();

//#endregion

//#region 																							C O N F I G

	private readonly ionAlert___askForLogout___config: interface___IonAlert = {
		header: this._LOCALE.translate(locale___SbSettingsMainPage.ionAlert___askForLogout___title),
		message: this._LOCALE.translate(locale___SbSettingsMainPage.ionAlert___askForLogout___message),
		buttons: [{
			text: this._LOCALE.translate(locale___App.ionAlert___button___yes),
			handler: () => {
				this._AUTH_LOGOUT.perform___logout();
			}
		}, {
			text: this._LOCALE.translate(locale___App.ionAlert___button___cancel),
			role: 'cancel',
			handler: () => {
				this.setState({ ionAlert___askForLogout___isOpen: false });
			}
		}]
	};

//#endregion

//#region 																							C O N S T R U C T O R

	constructor(
		public props: props___SbSettingsPage,
	) {
		super(props);
		this.state = state___SbSettingsMainPage___default;
	}

//#endregion

//#region 																							R E N D E R

	render() : React.ReactNode {
		return <>
			<IonPage>

				<IonAlert isOpen={ this.state.ionAlert___askForLogout___isOpen } {...this.ionAlert___askForLogout___config}></IonAlert>

				<MdEntryLanguageModal isOpen={ this.state.ionModal___MdEntryLanguageModal___isOpen } isDismissible={ true } event___onDidDismiss={() => { this.setState({ ionModal___MdEntryLanguageModal___isOpen: false }); }}/>

				<IonHeader className="ion-no-border" collapse="fade">
					<IonToolbar>
						<IonButtons slot="start">
							<IonBackButton defaultHref="/discover" text={ this._LOCALE.translate(locale___App.ionBackButton___text) }></IonBackButton>
						</IonButtons>
					</IonToolbar>
				</IonHeader>

				<IonContent forceOverscroll={ false }>

					<section className="sb-settings-main---container">

						<IonListHeader>
							<IonLabel>{ this._LOCALE.translate(locale___SbSettingsMainPage.account) }</IonLabel>
						</IonListHeader>
						<br />
						<IonCard>
							<IonList>
								<IonItem className="is-ion-item-button" button={ true } routerLink="/settings/auth">
									<i className="fa-solid fa-lock"></i>
									<IonLabel>{ this._LOCALE.translate(locale___SbSettingsMainPage.account___auth) }</IonLabel>
								</IonItem>
								<IonItem className="is-ion-item-button" button={ true } onClick={() => { this.setState({ ionAlert___askForLogout___isOpen: true }); }}>
									<i className="fas fa-power-off"></i>
									<IonLabel>{ this._LOCALE.translate(locale___SbSettingsMainPage.account___logout) }</IonLabel>
								</IonItem>
							</IonList>
						</IonCard>

						<br />

						<IonListHeader>
							<IonLabel>{ this._LOCALE.translate(locale___SbSettingsMainPage.preferences) }</IonLabel>
						</IonListHeader>
						<br />
						<IonCard>
							<IonList>
								<IonItem className="is-ion-item-button" button={ true } onClick={() => { this.setState({ ionModal___MdEntryLanguageModal___isOpen: true }); }}>
									<img src={ '/assets/localization/locale.' + this._LOCALE.language_get() + '.svg' } />
									<IonLabel>{ this._LOCALE.translate(locale___SbSettingsMainPage.preferences___language) }</IonLabel>
								</IonItem>
							</IonList>
						</IonCard>

						<br />

						<IonListHeader>
							<IonLabel>{ this._LOCALE.translate(locale___SbSettingsMainPage.support) }</IonLabel>
						</IonListHeader>
						<br />
						<IonCard>
							<IonList>
								<IonItem className="is-ion-item-button" button={ true } routerLink="/info/support">
									<i className="fa-solid fa-headset"></i>
									<IonLabel>{ this._LOCALE.translate(locale___SbSettingsMainPage.support___contact_us) }</IonLabel>
								</IonItem>
								{/*
									<IonItem className="is-ion-item-button" routerLink="/settings/datas" routerDirection="forward">
										<i className="fa-solid fa-database"></i>
										<IonLabel>Gestisci i dati personali</IonLabel>
									</IonItem>
								*/}
							</IonList>
						</IonCard>

						<br />

						<IonListHeader>
							<IonLabel>{ this._LOCALE.translate(locale___SbSettingsMainPage.about) }</IonLabel>
						</IonListHeader>
					
						<br />

						<IonCard>
							<IonList>
								<IonItem className="is-ion-item-button" routerLink="/info/eula" routerDirection="forward">
									<i className="fa-solid fa-balance-scale"></i>
									<IonLabel>{ this._LOCALE.translate(locale___SbSettingsMainPage.about___eula) }</IonLabel>
								</IonItem>
								<IonItem className="is-ion-item-button" routerLink="/info/licences" routerDirection="forward">
									<i className="fa-solid fa-key"></i>
									<IonLabel>{ this._LOCALE.translate(locale___SbSettingsMainPage.about___licences) }</IonLabel>
								</IonItem>
								<IonItem className="is-ion-item-button" routerLink="/info/copyright" routerDirection="forward">
									<i className="fa-solid fa-copyright"></i>
									<IonLabel>{ this._LOCALE.translate(locale___SbSettingsMainPage.about___copyright) }</IonLabel>
								</IonItem>
							</IonList>
						</IonCard>

						<br />
						<br />
						<br />

						<ComCopyrightComponent />

						<br />

					</section>

				</IonContent>

			</IonPage>
		</>;
	}

//#endregion

}